import type { CanRescheduleResponse } from '@shared/core/reschedule'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { RescheduleService } from 'src/services/reschedule.service'

export const GET_CAN_RESCHEDULE_CACHE_KEY = 'can-reschedule'

export function useCanReschedule(code: string, options?: UseQueryOptions<CanRescheduleResponse>) {
  const handleRetry = useHandleRetry()
  return useQuery([GET_CAN_RESCHEDULE_CACHE_KEY, code], () => RescheduleService.getCanReschedule(code), {
    enabled: !!code,
    staleTime: ms('5 minutes'),
    retry: handleRetry,
    ...options,
  })
}
